<template>
  <v-row no-gutters class="settings-tabs-row">
    <v-col cols="12" md="9">
      <SettingsTabs fill-height class="pa-2 pa-md-7">
        <slot></slot>
      </SettingsTabs>
    </v-col>

    <v-col cols="12" md="3">
      <SettingsNotifications></SettingsNotifications>
    </v-col>

    <v-col cols="12" md="9" class="text-center pt-5">
      <a
        href="#"
        class="fs-12 mt-5 tes-light-grey-text"
        :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'"
        @click.prevent="openDeleteDialog"
      >
      {{$t('pages.personalInformation.deleteAccount')}}
      </a>
      <ModalDelete
        @deleteItem="deleteItem"
        :loading="loading"
        :attentionText="deleteText"
        v-model="deleteDialog"
        @closeDeleteDialog="closeDeleteDialog"
      />
    </v-col>
  </v-row>
</template>

<script>
  import SettingsNotifications from "./SettingsNotifications";
  import SettingsTabs from "./SettingsTabs";
  import ModalDelete from "@/components/modals/ModalDelete";
  import { mapGetters } from "vuex";

  export default {
    components: {
      SettingsTabs,
      SettingsNotifications,
      ModalDelete
    },
    computed: {
      ...mapGetters("locale",["currentLocale"]),
      
      deleteText(){ return `${this.$t('pages.personalInformation.deleteAccount')}?`}
    },
    data: () => ({
      deleteDialog: false,
      loading: false
    }),
    methods: {
      openDeleteDialog(item) {
        this.deleteDialog = true;
      },
      deleteItem() {
        this.$store
          .dispatch("account/deleteAccount")
          .then(res => {
            if (res.data.success) {
              this.$store.dispatch("account/logOut");
            }
          })
          .finnaly(() => {
            this.loading = false;
          });
      },
      closeDeleteDialog() {
        this.deleteDialog = false;
      },
      onResize() {
        this.windowSize = {x: window.innerWidth, y: window.innerHeight};
      }
    },
    mounted() {
    }
  };
</script>

<style lang="scss">
  .settings-tabs-row {
    width: 100%;
  }
</style>

